var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c('div',{staticClass:"DescriptionList"},[_c('dl',_vm._l((_vm.listData),function(item,i){return _c('div',{key:i},[_c('dt',[_vm._v(_vm._s(item.dt))]),_c('dd',{domProps:{"innerHTML":_vm._s(item.dd)}})])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }